import { useEffect } from "react";
import { fetchStatiticsIncidenceOperatorDetailedFilterAction } from "../../../../redux/actions/statistics/statistics";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { StatisticsOperatorIncidenceDetailedList } from "./list/list";

export const StatisticsOperatorIncidenceDetailedContainer = () => {
    const dispatch = useAppDispatch();

    const { loading } = useAppSelector((state) => state.statisticsOperatorIncidenceDetailed.data);

    useEffect(() => {
        !loading && dispatch(fetchStatiticsIncidenceOperatorDetailedFilterAction());
    }, []);

    return (
        <>
            <StatisticsOperatorIncidenceDetailedList />
        </>
    );
};
